import React, { useState, useEffect, useContext, useRef } from "react";
import { useParams, withRouter } from "react-router-dom";
import { Navbar, Dropdown, Nav } from "react-bootstrap";
import EditorSpinner from "../../../Utils/EditorSaveSpinner";
import { ExternalUserContext } from "../../../Context/externalUserContext";
import { TemplateContext } from "../../../Context/templateContext";
import { useSelector, useDispatch } from "react-redux";
import "./CoverNavbar.scss";
import ColorPicker from "../../Colorpicker/Colorpicker";
import { downloadCover } from "../../../Store/Actions/CoverLetterActions";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import WarningPopup from "../../Modals/AppTemplateWarningPopup/WarningPopup";
import PreviewResume from "../../Modals/PreviewResumeModal/PreviewResumeModal";
import { coverBackgroundImage } from "../../../masterData";
import { jsonEditorContext } from "../../../Context/jsonEditorContext";
import { CoverUpdateContext } from "../../../Context/coverUpdateContext";
import Modal from "react-bootstrap/Modal";
import { undoRedoCover } from "../../../Store/Actions/undoRedoActions";
import DownloadPopup from "../../DownloadPopup/DownloadPopup";
import "../../RangeSilder/RangeSilder.scss";
import LoginPopup from "../../Modals/LoginPopup/LoginPopup";
import { coverEditActions } from "../../../Store/Actions/CoverLetterActions";
import { userTypeContext } from "../../../Context/FreeOrProContext";
import OutsideClickHandler from "react-outside-click-handler";
import Qrtemplate from "../../Qrtemplate/Qrtemplate";
import Collapse from "react-bootstrap/Collapse";

function EditorHeader(props) {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { history } = useSelector((state) => state.undoRedoCover);
  const dropdownRef = useRef();

  const fontSelection = [
    {
      font: [
        "Raleway",
        "Rubik",
        "Open Sans",
        "Poppins",
        "Lato",
        "Fira Sans",
        "PT Sans",
        "PT Sans Caption",
        "Source Sans Pro",
        "Lora",
        "Yantramanav",
        "Quicksand",
        "Ubuntu",
        "Oswald",
        "Roboto",
        "Roboto Condensed",
        "Hind",
        "Overpass",
      ],
      label: "Primary Font",
      key: "primary",
      name: "titleFont",
    },
    {
      font: [
        "Raleway",
        "Rubik",
        "Open Sans",
        "Poppins",
        "Lato",
        "Fira Sans",
        "PT Sans",
        "PT Sans Caption",
        "Source Sans Pro",
        "Lora",
        "Yantramanav",
        "Quicksand",
        "Ubuntu",
        "Oswald",
        "Roboto",
        "Roboto Condensed",
        "Hind",
        "Overpass",
      ],
      label: "Body Font",
      key: "body",
      name: "bodyFont",
    },
  ];

  const customColor = [
    {
      varient: "primaryColor",
      label: "Primary Color",
    },
    {
      varient: "secondaryColor",
      label: "Secondary Color",
    },
    {
      varient: "sectionTitleColor",
      label: "Section Title Background Color",
    },
    {
      varient: "bgColor",
      label: "Page Color",
    },
  ];

  const { setIsJson, setIsSample, coverJson, isCoverJson } =
    useContext(jsonEditorContext);
  const { isLogin, setIsLogin } = useContext(ExternalUserContext);
  const { showTemplate, setShowTemplate } = useContext(TemplateContext);
  const {
    fontHandler,
    sizeHandler,
    multiColorHandler,
    colorHandler,
    setCoverUpdated,
    backgroundUpdate,
  } = useContext(CoverUpdateContext);

  const [tempData, setTempData] = useState("");
  const [showPreview, setShowPreview] = useState(false);
  const [showWarningPopup, setShowWarningPopup] = useState(false);
  const [randUpdate, setRandUpdate] = useState(false);
  const [hasClass, setHasClass] = useState(false);
  const [showDesignSection, setShowDesignSection] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [showMediumDesignbar, setShowMediumDesignbar] = useState(false);
  const [openSection, setOpenSection] = useState(false);
  const [openFonts, setOpenFonts] = useState(false);
  const [openColors, setOpenColors] = useState(false);
  const [openBackground, setOpenBackground] = useState(false);
  const [openLayout, setOpenLayout] = useState(false);
  const {
    userType,
    resumeCount,
    showProPopup,
    setShowProPopup,
    setShowProPopupMessage,
    popupType,
    setPopupType,
  } = useContext(userTypeContext);
  const handleEventKey = (eventKey, event) => {
    props.setEditorEventKey(eventKey);
  };

  const { coverLetter } = useSelector((state) => state.coverParticular);
  const selectedCoverLetter = useSelector(
    (state) => state.coverParticular.coverLetter
  );
  const editorData = useSelector((state) => state.coverData);

  const templateData = useSelector((state) => state.TemplateParticular.data);

  const dataCustomize = isCoverJson
    ? coverJson && coverJson.customization && coverJson.customization
    : props &&
      props.resumeFields &&
      props.resumeFields.customization &&
      props.resumeFields.customization;

  const { fonts, colors, background } =
    dataCustomize && dataCustomize ? dataCustomize : "";

  const styles = {
    primaryColor: colors && colors.primaryColor,
    secondaryColor: colors && colors.secondaryColor,
    sectionTitleColor: colors && colors.sectionTitleColor,
    bgColor: colors && colors.bgColor,
    linkColor: colors && colors.linkColor,
    titleFont: fonts && fonts.titleFont,
    bodyFont: fonts && fonts.bodyFont,
    titleFontSize: fonts && fonts.titleFontSize,
    bodyFontSize: fonts && fonts.bodyFontSize,
    bodyFontColor: colors && colors.descriptionColor,
    bold: fonts && fonts.bold,
    medium: fonts && fonts.medium,
    regular: fonts && fonts.regular,
  };

  useEffect(() => {
    setTempData(templateData);
  }, [templateData]);

  const handleHide = () => {
    setShowLogin(false);
  };

  function showTemplatePopup() {
    if (coverLetter && coverLetter.status && coverLetter.status == "2") {
      setShowWarningPopup(true);
    } else {
      props.ShowTemplate();
    }
  }

  const showSamplePopup = () => {
    props.showSamplePopup();
  };
  const showTemplatePopupForAppUser = () => {
    setShowWarningPopup(false);
    props.ShowTemplate();
  };
  const handleHideWarning = () => {
    setShowWarningPopup(false);
  };
  const handlePreview = () => {
    setShowPreview(true);
  };

  const hidePreview = () => {
    setShowPreview(false);
  };
  const showCustomColor = () => {};

  //For Font Size

  const fontSize = styles && styles.bodyFontSize;
  const [value, setValue] = useState();
  const [dragEnd, setDragEnd] = useState(false);
  const removePx = fontSize?.split("px").shift();
  const path = window.location.pathname;

  useEffect(() => {
    setValue(removePx);
  }, [fonts]);

  //   useEffect(() => {
  //     if (dragEnd) {
  //       handleSize(value);
  //     }
  //   }, [value]);
  const handleChange = (e) => {
    let size = e.target.value;
    setValue(size);
    props.sizeHandler(
      "titleFontSize",
      `${parseInt(size) + 8}px`,
      "bodyFontSize",
      `${size}px`
    );
    // setDragEnd(true);
  };

  //   const handleSize = (size) => {
  //     sizeHandler(
  //       "titleFontSize",
  //       `${parseInt(size) + 8}px`,
  //       "bodyFontSize",
  //       `${size}px`
  //     );
  //   };
  const handleBlur = (e) => {
    props.resumeUpdate(e, "visual");
  };

  const handleCustomColor = (e) => {
    props.resumeUpdate(e, "visual");
  };
  //For Custom Color

  //For Change background
  const handleImageChange = (img, index) => {
    props.backgroundUpdate(img);
  };

  function undo(e) {
    setRandUpdate(true);
    let data = history;
    if (data.currentIndex > 0) {
      let undoContent = data.timeline[data.currentIndex - 1].editorData;
      props.setResumeFields(undoContent);
      data.currentIndex = data.currentIndex - 1;
      dispatch(undoRedoCover({ history: data }));
    }
  }

  useEffect(() => {
    if (randUpdate) {
      props.resumeUpdate(true, "undo");
      setRandUpdate(false);
    }
  }, [props.resumeFields]);

  function redo(e) {
    setRandUpdate(true);
    let data = history;
    if (data.currentIndex >= 0) {
      let timeLineLength = data.timeline.length;
      if (data.currentIndex + 1 <= timeLineLength) {
        let undoContent = data.timeline[data.currentIndex + 1].editorData;
        props.setResumeFields(undoContent);
        data.currentIndex = data.currentIndex + 1;
        dispatch(undoRedoCover({ history: data }));
      }
    }
  }

  document.onkeydown = function (evt) {
    evt = evt || window.event;
    if (evt.ctrlKey && evt.keyCode == 90) {
      undo();
    } else if (evt.ctrlKey && evt.keyCode == 89) {
      redo();
    }
  };

  const [modal, setModal] = useState(false);
  const handleToggle = () => {
    if (path && path.includes("create")) {
      setShowLogin(true);
    } else {
      if (userType && userType == "free") {
        let data =
          props &&
          props.resumeFields &&
          props.resumeFields.lockedFeatures &&
          props.resumeFields.lockedFeatures;
        if (data && data.length > 0) {
          setShowProPopup(true);
          setPopupType("download");
          setShowProPopupMessage("Please upgrade to Pro");
        } else {
          setModal(!modal);
        }
      } else {
        setModal(!modal);
      }
    }
  };

  const dropdownToggle = () => {
    setTimeout(() => {
      if (dropdownRef.current.classList.contains("show")) {
        setHasClass(true);
      } else {
        setHasClass(false);
      }
    }, 100);
  };

  const overflow = {
    overflowX:
      hasClass && window.innerWidth < 1200
        ? "inherit"
        : !hasClass && window.innerWidth < 1200
        ? "scroll"
        : "",
  };

  const handleDesign = () => {
    setShowDesignSection(!showDesignSection);
  };

  const handleMediumDesignbar = () => {
    setShowMediumDesignbar(!showMediumDesignbar);
  };

  function showTemplateNewPopup() {
    if (tempData && tempData.status && tempData.status == "2") {
      setShowWarningPopup(true);
    } else {
      props.ShowTemplate();
    }
  }
  const toggleFontsAccordion = () => {
    setOpenFonts(!openFonts);
  };
  const toggleColorsAccordion = () => {
    setOpenColors(!openColors);
  };

  const toggleBackgroundAccordion = () => {
    setOpenBackground(!openBackground);
  };

  const toggleLayoutAccordion = () => {
    setOpenLayout(!openLayout);
  };

  const handleLayoutChange = (checked) => {
    let data = { ...editorData };

    const body = {
      title:
        coverLetter && coverLetter && coverLetter.title
          ? coverLetter.title
          : "",
      body: "Body",
      content: JSON.stringify(data),
      completed: false,
      isLetter: checked == "letter" ? 1 : 0,
      type: "cover_letter",
      template_id: coverLetter && coverLetter && coverLetter.template_id,
    };
    dispatch(coverEditActions(id, body, "sizeHandle"));
  };

  return (
    <>
      <WarningPopup
        show={showWarningPopup}
        hide={handleHideWarning}
        showTemplatePopup={showTemplatePopupForAppUser}
      />
      <PreviewResume
        id={props.id}
        cover={props.cover}
        showPreview={showPreview}
        hidePreview={hidePreview}
        setIsSample={props.setIsCoverSample}
      />
      <LoginPopup show={showLogin} hide={handleHide} />

      <div className="parent-desingerbar ">
        <div
          className="p-2 align-items-center cover-designbar"
          // style={overflow}
        >
          <div>
            {/* {history && (
              <div className="btn-wrapper">
                {history && history.currentIndex && history.currentIndex > 0 ? (
                  <>
                    <button className="w-50" onClick={(e) => undo("undo")}>
                      <img
                        src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/undo.svg`}
                        className=""
                      />
                    </button>
                  </>
                ) : (
                  <>
                    <button className="w-50" style={{ opacity: "0.5" }}>
                      <img
                        src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/undo.svg`}
                        className=""
                      />
                    </button>
                  </>
                )}
                {history.currentIndex != history.timeline.length - 1 ? (
                  <>
                    <button className="w-50" onClick={(e) => redo("redo")}>
                      <img
                        src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/redo.svg`}
                        className=""
                      />
                    </button>
                  </>
                ) : (
                  <>
                    <button className="w-50" style={{ opacity: "0.5" }}>
                      <img
                        src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/redo.svg`}
                        className=""
                      />
                    </button>
                  </>
                )}
              </div>
            )}
            <div className="toolbox-separator"></div> */}
            {/* <div className="btn-wrapper">
              <Dropdown
                ref={dropdownRef}
                className="d-inline mx-2 design-dropdown"
                onToggle={dropdownToggle}
              >
                <Dropdown.Toggle
                  id="dropdown-autoclose-false"
                  style={{ paddingRight: "20px" }}
                >
                  Design
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <div className="mb-3 px-3 pt-2">
                    <label className="formlable d-block">Font Size</label>

                    <div className="size_btn_editor">
                      <input
                        type="range"
                        className="range_slider range_slider_width"
                        min="11"
                        max="16"
                        name="level"
                        value={value}
                        onChange={(e) => handleChange(e)}
                        onBlur={() => handleBlur()}
                      />
                      <span className="font_size_handler">{value} px</span>
                    </div>
                  </div>

                  <Dropdown.Item disabled>
                    {" "}
                    <div className="mb-3">
                      {fontSelection &&
                        fontSelection.map((res, index) => (
                          <>
                            <label className="formlable d-block">
                              {res.label}
                            </label>

                            <div className="select-div position-relative">
                              <select
                                onChange={(e) => props.fontHandler(e, res.name)}
                                value={styles && styles[res.name]}
                                className="form-control  editor-font-input"
                                style={{ appearance: "none" }}
                              >
                                {res &&
                                  res.font.map((response) => (
                                    <option
                                      style={{ fontFamily: response }}
                                      value={response}
                                    >
                                      {response}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </>
                        ))}
                    </div>
                  </Dropdown.Item>
                
                    <>
                      <div className="font-color-section">
                        <label className="formlable d-block">Colors</label>
                        <div className="row">
                          {fonts &&
                            fonts.multi_color_option &&
                            fonts.multi_color_option.map((res, index) => (
                              <div className="col-md-3">
                                <div
                                  className="multicircle mx-2"
                                  onClick={() =>
                                    props.multiColorHandler(
                                      res.primary_color,
                                      res.secondary_color
                                    )
                                  }
                                  style={{
                                    width: "30px",
                                    height: "30px",
                                    backgroundColor: "red",
                                    display: "flex",
                                    borderRadius: "50%",
                                    overflow: "hidden",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: "50%",
                                      height: "100%",
                                      backgroundColor: res.primary_color,
                                    }}
                                  ></div>
                                  <div
                                    style={{
                                      width: "50%",
                                      height: "100%",
                                      backgroundColor: res.secondary_color,
                                    }}
                                  ></div>
                                </div>
                              </div>
                            ))}
                        </div>

                        <p className="pt-2" onClick={showCustomColor}>
                          Use Custom Color
                        </p>

                        {customColor &&
                          customColor.map((res, index) => (
                            <>
                              {styles && styles[res.varient] && (
                                <div className="mb-2" key={index}>
                                  <label className="formlable">
                                    {res.label}
                                  </label>
                                  <ul className="fontbtn editor-color-picker d-flex justify-content-between">
                                    <li className="w-100">
                                      <div className="background">
                                        <label className="color-selector">
                                          <span
                                            className="circle"
                                            style={{
                                              background:
                                                styles && styles[res.varient],
                                            }}
                                          />
                                          <span>
                                            {styles && styles[res.varient]}
                                          </span>

                                          <input
                                            type="color"
                                            className="hidden"
                                            value={
                                              styles && styles[res.varient]
                                            }
                                            onChange={(e) =>
                                              props.colorHandler(e, res.varient)
                                            }
                                            onBlur={handleCustomColor}
                                            style={{ cursor: "pointer" }}
                                          />
                                        </label>
                                      </div>
                                    </li>
                                  </ul>
                                </div>
                              )}
                            </>
                          ))}
                      </div>

                      <Dropdown.Item disabled>
                        <label className="formlable d-block">Background</label>
                        <div className="row m-0 nvBr">
                          {coverBackgroundImage &&
                            coverBackgroundImage.map((res, index) => (
                              <div
                                key={index}
                                className="col-md-3 mt-2 change_modal_row"
                              >
                                {background && background.bgImage == res ? (
                                  <>
                                    <div className="  backimg_select image_change_modal_img_div">
                                      <div
                                        style={{ cursor: "pointer" }}
                                        className={`background_change background_b0${index}`}
                                        onClick={() =>
                                          handleImageChange(res, index)
                                        }
                                      />
                                    </div>
                                  </>
                                ) : (
                                  <div className=" image_change_modal_img_div">
                                    <div
                                      style={{ cursor: "pointer" }}
                                      className={`background_change  background_b0${index}`}
                                      onClick={() =>
                                        handleImageChange(res, index)
                                      }
                                    />
                                  </div>
                                )}
                              </div>
                            ))}
                        </div>
                      </Dropdown.Item>
                    </>
                  
                </Dropdown.Menu>
              </Dropdown>
            </div> */}

            {/* <div className="btn-wrapper design-btn-wrapper">
              <button onClick={handleDesign}>
                <i class="fa fa-tint mr-2" aria-hidden="true"></i> Design
              </button>
            </div> */}

            <div className="btn-wrapper">
              <button
                onClick={toggleFontsAccordion}
                aria-expanded={openFonts}
                aria-controls="accordion-content"
                className={
                  openFonts ? "accordion-button active" : "accordion-button"
                }
              >
                <i class="fa fa-font mr-2" aria-hidden="true"></i> Fonts
                <span className="icon-container">
                  <i
                    className={`fa ${
                      openFonts ? "fa-chevron-up" : "fa-chevron-down"
                    }`}
                  />
                </span>
              </button>
              <Collapse in={openFonts}>
                <div
                  id="accordion-content"
                  className={`accordion-content${openFonts ? " open" : ""}`}
                >
                  <div className="">
                    {/* Font Size */}
                    <div className="mb-3  pt-2">
                      <label className="formlable d-block">Font Size</label>

                      <div className="size_btn_editor">
                        <input
                          type="range"
                          className="range_slider range_slider_width"
                          min="11"
                          max="16"
                          name="level"
                          value={value}
                          onChange={(e) => handleChange(e)}
                          onBlur={handleBlur}
                        />
                        <span className="font_size_handler">{value} px</span>
                      </div>
                    </div>
                    {/* Font Size */}
                    {/* Font Selection */}

                    <div className="mb-3">
                      {fontSelection &&
                        fontSelection.map((res, index) => (
                          <>
                            <label className="formlable d-block">
                              {res.label}
                            </label>

                            <div className="select-div position-relative">
                              <select
                                onChange={(e) => props.fontHandler(e, res.name)}
                                value={styles && styles[res.name]}
                                className="form-control  editor-font-input"
                                style={{ appearance: "none" }}
                              >
                                {res &&
                                  res.font.map((response) => (
                                    <option
                                      style={{ fontFamily: response }}
                                      value={response}
                                    >
                                      {response}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </>
                        ))}
                    </div>
                  </div>
                </div>
              </Collapse>
            </div>
            <div className="btn-wrapper">
              <button
                onClick={toggleColorsAccordion}
                aria-expanded={openColors}
                aria-controls="accordion-content"
                className={
                  openColors ? "accordion-button active" : "accordion-button"
                }
              >
                <i class="fa fa-tint mr-2" aria-hidden="true"></i> Colors
                <span className="icon-container">
                  <i
                    className={`fa ${
                      openColors ? "fa-chevron-up" : "fa-chevron-down"
                    }`}
                  />
                </span>
              </button>
              <Collapse in={openColors}>
                <div
                  id="accordion-content"
                  className={`accordion-content${openColors ? " open" : ""}`}
                >
                  <div className="">
                    {/* Font Color Select */}
                    <div className="font-color-section">
                      <div className=" mt-2">
                        <label className="formlable d-block">Colors</label>
                        <div className="row m-0">
                          {fonts &&
                            fonts.multi_color_option &&
                            fonts.multi_color_option.map((res, index) => (
                              <div className="col-md-3">
                                <div
                                  className="multicircle mx-2 cursor"
                                  onClick={() =>
                                    props.multiColorHandler(
                                      res.primary_color,
                                      res.secondary_color
                                    )
                                  }
                                  style={{
                                    width: "30px",
                                    height: "30px",
                                    backgroundColor: "red",
                                    display: "flex",
                                    borderRadius: "50%",
                                    overflow: "hidden",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: "50%",
                                      height: "100%",
                                      backgroundColor: res.primary_color,
                                    }}
                                  ></div>
                                  <div
                                    style={{
                                      width: "50%",
                                      height: "100%",
                                      backgroundColor: res.secondary_color,
                                    }}
                                  ></div>
                                </div>
                              </div>
                            ))}
                        </div>

                        <label className="formlable d-block pt-3">
                          Use custom color :
                        </label>

                        {customColor &&
                          customColor.map((res, index) => (
                            <>
                              {styles && styles[res.varient] && (
                                <div className="mb-2" key={index}>
                                  <label className="formlable">
                                    {res.label}
                                  </label>
                                  <ul className="fontbtn editor-color-picker d-flex justify-content-between">
                                    <li className="w-100">
                                      <div className="background">
                                        <label className="color-selector">
                                          <span
                                            className="circle"
                                            style={{
                                              background:
                                                styles && styles[res.varient],
                                            }}
                                          />
                                          <span>
                                            {styles && styles[res.varient]}
                                          </span>

                                          <input
                                            id={`color${index}`}
                                            type="color"
                                            className="hidden"
                                            value={
                                              styles && styles[res.varient]
                                            }
                                            onChange={(e) =>
                                              props.colorHandler(e, res.varient)
                                            }
                                            onBlur={handleCustomColor}
                                            style={{ cursor: "pointer" }}
                                          />
                                        </label>
                                      </div>
                                    </li>
                                  </ul>
                                </div>
                              )}
                            </>
                          ))}
                      </div>
                      {/* Font Color Select */}
                      <div className="toolbox-separator"></div>
                      {/* Resume Background Select */}

                      <label className="formlable d-block mt-4">
                        Background
                      </label>
                      <div className="row m-0">
                        {coverBackgroundImage &&
                          coverBackgroundImage.map((res, index) => (
                            <div
                              key={index}
                              className="col-md-3 mt-2 change_modal_row"
                            >
                              {background && background.bgImage == res ? (
                                <>
                                  <div className="  backimg_select image_change_modal_img_div">
                                    <div
                                      style={{ cursor: "pointer" }}
                                      className={`background_change background_b0${index}`}
                                      onClick={() =>
                                        handleImageChange(res, index)
                                      }
                                    />
                                  </div>
                                </>
                              ) : (
                                <div className=" image_change_modal_img_div">
                                  <div
                                    style={{ cursor: "pointer" }}
                                    className={`background_change  background_b0${index}`}
                                    onClick={() =>
                                      handleImageChange(res, index)
                                    }
                                  />
                                </div>
                              )}
                            </div>
                          ))}
                      </div>
                    </div>
                    {/* Resume Background Select */}
                  </div>
                </div>
              </Collapse>
            </div>

            {/* Background */}

            <div className="btn-wrapper">
              <button
                onClick={toggleBackgroundAccordion}
                aria-expanded={openBackground}
                aria-controls="accordion-content"
                className={
                  openBackground
                    ? "accordion-button active"
                    : "accordion-button"
                }
              >
                <i class="fa fa-tint mr-2" aria-hidden="true"></i> Backgrounds
                <span className="icon-container">
                  <i
                    className={`fa ${
                      openBackground ? "fa-chevron-up" : "fa-chevron-down"
                    }`}
                  />
                </span>
              </button>
              <Collapse in={openBackground}>
                <div
                  id="accordion-content"
                  className={`accordion-content${
                    openBackground ? " open" : ""
                  }`}
                >
                  <div className="">
                    {/* Font Color Select */}
                    <div className="font-color-section">
                      <label className="formlable d-block mt-4">
                        Background
                      </label>
                      <div className="row m-0">
                        {coverBackgroundImage &&
                          coverBackgroundImage.map((res, index) => (
                            <div
                              key={index}
                              className="col-md-3 mt-2 change_modal_row"
                            >
                              {background && background.bgImage == res ? (
                                <>
                                  <div className="  backimg_select image_change_modal_img_div">
                                    <div
                                      style={{ cursor: "pointer" }}
                                      className={`background_change background_b0${index}`}
                                      onClick={() =>
                                        handleImageChange(res, index)
                                      }
                                    />
                                  </div>
                                </>
                              ) : (
                                <div className=" image_change_modal_img_div">
                                  <div
                                    style={{ cursor: "pointer" }}
                                    className={`background_change  background_b0${index}`}
                                    onClick={() =>
                                      handleImageChange(res, index)
                                    }
                                  />
                                </div>
                              )}
                            </div>
                          ))}
                      </div>
                    </div>
                    {/* Resume Background Select */}
                  </div>
                </div>
              </Collapse>
            </div>

            {/* Layouts */}

            <div className="btn-wrapper">
              <button
                onClick={toggleLayoutAccordion}
                aria-expanded={openLayout}
                aria-controls="accordion-content"
                className={
                  openLayout ? "accordion-button active" : "accordion-button"
                }
              >
                <i class="fa fa-tint mr-2" aria-hidden="true"></i> Page Size
                <span className="icon-container">
                  <i
                    className={`fa ${
                      openLayout ? "fa-chevron-up" : "fa-chevron-down"
                    }`}
                  />
                </span>
              </button>
              <Collapse in={openLayout}>
                <div
                  id="accordion-content"
                  className={`accordion-content${openLayout ? " open" : ""}`}
                >
                  <div className="">
                    {/* Font Color Select */}
                    <div className="font-color-section">
                      <div className="row mt-2 justify-content-between ">
                        <p
                          className="pt-2 col-md-6"
                          style={{ fontSize: "12px" }}
                        >
                          Document size:
                        </p>
                        <div className="col-md-6">
                          <div className="row type-switch-div justify-content-between">
                            <div
                              className={
                                selectedCoverLetter &&
                                selectedCoverLetter &&
                                selectedCoverLetter.isLetter
                                  ? ` type-switch-selected col-md-6 type-switch`
                                  : "col-md-6 type-switch"
                              }
                              onClick={() =>
                                handleLayoutChange("letter", "document_size")
                              }
                            >
                              Letter
                            </div>
                            <div
                              className={
                                selectedCoverLetter &&
                                selectedCoverLetter &&
                                selectedCoverLetter.isLetter
                                  ? ` col-md-6 type-switch`
                                  : " type-switch-selected col-md-6 type-switch"
                              }
                              onClick={() =>
                                handleLayoutChange("a4", "document_size")
                              }
                            >
                              A4
                            </div>
                          </div>
                        </div>

                        {/* <div className="p-0 mr-2">
                <BootstrapSwitchButton
                  checked={
                    resume && resume.resume && resume.resume.isLetter
                      ? true
                      : false
                  }
                  onstyle="outline-success"
                  offstyle="outline-success"
                  width={77}
                  onlabel="Letter"
                  offlabel="A4"
                  size="sm"
                  onChange={(checked) => handleChange(checked, "document_size")}
                />
              </div> */}
                      </div>
                    </div>
                    {/* Resume Background Select */}
                  </div>
                </div>
              </Collapse>
            </div>

            <div className="btn-wrapper">
              <button onClick={showSamplePopup}>
                <i class="fa fa-database mr-2" aria-hidden="true"></i> Import
                Content
              </button>
            </div>
            <div className="btn-wrapper">
              <button
                // onClick={toggleSectionAccordion}
                // aria-expanded={openSection}
                aria-controls="accordion-content"
                className={
                  openSection ? "accordion-button active" : "accordion-button"
                }
              >
                <i class="fa fa-file-text-o mr-2" aria-hidden="true"></i>{" "}
                Template
                <span className="icon-container"></span>
              </button>
              <Collapse in={true}>
                <div
                  id="accordion-content"
                  className={`accordion-content open`}
                >
                  <Qrtemplate showTemplateNewPopup={showTemplateNewPopup} />
                </div>
              </Collapse>
            </div>
          </div>

          <div className="">
            <div className="btn-wrapper">
              <button onClick={handlePreview}>
                <span className="">
                  <i class="fa fa-eye mr-2" aria-hidden="true"></i> Preview
                </span>
              </button>
            </div>
            <div className="btn-wrapper">
              <button onClick={() => props.shareShow()}>
                <span className="">
                  <i class="fa fa-share-alt mr-2" aria-hidden="true"></i> Share
                </span>
              </button>
            </div>
            <div className="btn-wrapper">
              <button onClick={() => handleToggle()}>
                <span className="">
                  <i class="fa fa-download mr-2" aria-hidden="true"></i>{" "}
                  Download
                </span>
              </button>
              {modal && modal && (
                <DownloadPopup
                  show={modal}
                  handleToggle={handleToggle}
                  type="cover"
                />
              )}
            </div>
          </div>
        </div>
      </div>

      {showDesignSection && showDesignSection && (
        <OutsideClickHandler
          onOutsideClick={(e, value) => {
            const parentWithClass = e.target.closest(".design-section-wrapper");
            const anotherParentWithClass = e.target.closest(
              ".design-btn-wrapper"
            );

            if (parentWithClass == null && anotherParentWithClass == null) {
              setShowDesignSection(false);
            } else {
              // setOutSideClick(false);
            }
          }}
        >
          <div className="cover-design-section-wrapper cover-designbar">
            {/* Font Size */}
            <div className="mb-3  pt-2">
              <label className="formlable d-block">Font Size</label>

              <div className="size_btn_editor">
                <input
                  type="range"
                  className="range_slider range_slider_width"
                  min="11"
                  max="16"
                  name="level"
                  value={value}
                  onChange={(e) => handleChange(e)}
                  onBlur={handleBlur}
                />
                <span className="font_size_handler">{value} px</span>
              </div>
            </div>
            {/* Font Size */}
            {/* Font Selection */}

            <div className="mb-3">
              {fontSelection &&
                fontSelection.map((res, index) => (
                  <>
                    <label className="formlable d-block">{res.label}</label>

                    <div className="select-div position-relative">
                      <select
                        onChange={(e) => props.fontHandler(e, res.name)}
                        value={styles && styles[res.name]}
                        className="form-control  editor-font-input"
                        style={{ appearance: "none" }}
                      >
                        {res &&
                          res.font.map((response) => (
                            <option
                              style={{ fontFamily: response }}
                              value={response}
                            >
                              {response}
                            </option>
                          ))}
                      </select>
                    </div>
                  </>
                ))}
            </div>
            {/* Font Selection */}
            <div className="toolbox-separator"></div>
            {/* Font Color Select */}
            <div className="font-color-section mt-4">
              <label className="formlable d-block">Colors</label>
              <div className="row">
                {fonts &&
                  fonts.multi_color_option &&
                  fonts.multi_color_option.map((res, index) => (
                    <div className="col-md-3">
                      <div
                        className="multicircle mx-2 cursor"
                        onClick={() =>
                          props.multiColorHandler(
                            res.primary_color,
                            res.secondary_color
                          )
                        }
                        style={{
                          width: "30px",
                          height: "30px",
                          backgroundColor: "red",
                          display: "flex",
                          borderRadius: "50%",
                          overflow: "hidden",
                        }}
                      >
                        <div
                          style={{
                            width: "50%",
                            height: "100%",
                            backgroundColor: res.primary_color,
                          }}
                        ></div>
                        <div
                          style={{
                            width: "50%",
                            height: "100%",
                            backgroundColor: res.secondary_color,
                          }}
                        ></div>
                      </div>
                    </div>
                  ))}
              </div>

              <label className="formlable d-block pt-3">
                Use custom color :
              </label>

              {customColor &&
                customColor.map((res, index) => (
                  <>
                    {styles && styles[res.varient] && (
                      <div className="mb-2" key={index}>
                        <label className="formlable">{res.label}</label>
                        <ul className="fontbtn editor-color-picker d-flex justify-content-between">
                          <li className="w-100">
                            <div className="background">
                              <label className="color-selector">
                                <span
                                  className="circle"
                                  style={{
                                    background: styles && styles[res.varient],
                                  }}
                                />
                                <span>{styles && styles[res.varient]}</span>

                                <input
                                  id={`color${index}`}
                                  type="color"
                                  className="hidden"
                                  value={styles && styles[res.varient]}
                                  onChange={(e) =>
                                    props.colorHandler(e, res.varient)
                                  }
                                  onBlur={handleCustomColor}
                                  style={{ cursor: "pointer" }}
                                />
                              </label>
                            </div>
                          </li>
                        </ul>
                      </div>
                    )}
                  </>
                ))}
            </div>
            {/* Font Color Select */}
            <div className="toolbox-separator"></div>
            {/* Resume Background Select */}

            <label className="formlable d-block mt-4">Background</label>
            <div className="row m-0">
              {coverBackgroundImage &&
                coverBackgroundImage.map((res, index) => (
                  <div key={index} className="col-md-3 mt-2 change_modal_row">
                    {background && background.bgImage == res ? (
                      <>
                        <div className="  backimg_select image_change_modal_img_div">
                          <div
                            style={{ cursor: "pointer" }}
                            className={`background_change background_b0${index}`}
                            onClick={() => handleImageChange(res, index)}
                          />
                        </div>
                      </>
                    ) : (
                      <div className=" image_change_modal_img_div">
                        <div
                          style={{ cursor: "pointer" }}
                          className={`background_change  background_b0${index}`}
                          onClick={() => handleImageChange(res, index)}
                        />
                      </div>
                    )}
                  </div>
                ))}
            </div>

            {/* Resume Background Select */}
          </div>
        </OutsideClickHandler>
      )}
    </>
  );
}

export default EditorHeader;
